import React from 'react';
import './OrderShortSummaryWithImage.css'; // You can style this separately

function OrderShortSummaryWithImage({ products = [], totalAmount = 0, shippingCharges = 200 }) {
  if (!products.length) {
    return <div className="no-order-data">No items to review.</div>;
  }

  const subtotal = totalAmount - shippingCharges;

  return (
    <div className="order-short-summary">
      <h2>Review Your Order</h2>
      <div className="summary-header">
        <p>Product</p>
        <p>Title</p>
        <p>Size</p>
        <p>Qty</p>
        <p>Total</p>
      </div>
      {/* <hr /> */}

      {products.map((product, index) => {
        const { image, name, size, quantity, price } = product;
        let adjustedPrice = price;

        if (size === "Unstitched") {
          adjustedPrice = price - 1000;
        }

        return (
          <div className="summary-row" key={index}>
            <img
              src={image}
              alt={name}
              className="summary-image"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = 'https://via.placeholder.com/60';
              }}
            />
            <p>{name}</p>
            <p>{size}</p>
            <p>{quantity}</p>
            <p>PKR {adjustedPrice * quantity}</p>
          </div>
        );
      })}

      <hr />
      <div className="summary-totals">
        <div className="row">
          <span>Subtotal:</span>
          <span>PKR {subtotal}</span>
        </div>
        <div className="row">
          <span>Shipping:</span>
          <span>PKR {shippingCharges}</span>
        </div>
        <div className="row total">
          <strong>Total:</strong>
          <strong>PKR {totalAmount}</strong>
        </div>
      </div>
    </div>
  );
}

export default OrderShortSummaryWithImage;
